import { change } from 'redux-form';

import { handleErrorException, success, loading } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { DISTRICT_SETTINGS_FORM_NAME } from 'Common/FormEnum';
import { ControlInfoEnum } from 'Common/FieldEnum';

import * as types from './types';

export const getControlDistrictInfo = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CONTROL_INFO_FETCHING, true));

      const response = await MPWWebApi.getGeneric(`ControlInfo/1`);

      dispatch(
        success(types.CONTROL_INFO_GET_DISTRICT_INFO, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while retrieving Control Information. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.CONTROL_INFO_FETCH_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.CONTROL_INFO_FETCHING, false));
    }
  };
};

export const saveControlDistrictInfo = obj => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CONTROL_INFO_SUBMITTING, true));

      await MPWWebApi.postGenericInsertUpdate(`ControlInfo`, obj);
      dispatch(success(types.CONTROL_INFO_SUBMIT_SUCCESS));
      dispatch(getControlDistrictInfo());

      dispatch(resetDirty());
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message:
          'An error occurred while saving Control Information. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.CONTROL_INFO_SUBMIT_ERROR, defaultError)
      );
    }

    dispatch(loading(types.CONTROL_INFO_SUBMITTING, false));
  };
};

export const clearControlInfoErrorSuccess = () => {
  return {
    type: types.CONTROL_INFO_CLEAR_ERROR_SUCCESS,
  };
};

export const getMobileInventoryLicenseCount = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MOBILE_INVENTORY_LICENSE_COUNT_FETCHING, true));
      const response = await MPWWebApi.getGeneric(
        'ControlInfo/GetMobileInventoryLicenseCount'
      );

      dispatch(
        success(types.MOBILE_INVENTORY_LICENSE_COUNT_DATA, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Product License Information. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.MOBILE_INVENTORY_LICENSE_COUNT_FETCH_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.MOBILE_INVENTORY_LICENSE_COUNT_FETCHING, false));
    }
  };
};

export const writeMobileInventoryData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MOBILE_SYNC_INFO_FETCHING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'ControlInfo/WriteMobileInventoryData',
        {}
      );

      dispatch(success(types.MOBILE_SYNC_INFO_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while running Mobile Sync Info. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.MOBILE_SYNC_INFO_FETCH_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.MOBILE_SYNC_INFO_FETCHING, false));
    }
  };
};

export const setEnableMobileInventory = () => {
  return change(
    DISTRICT_SETTINGS_FORM_NAME,
    ControlInfoEnum.INV_AppEnabled,
    true
  );
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/districtInfo/actions.js